import { render, staticRenderFns } from "./QualityPPsManagerForm.vue?vue&type=template&id=26228e30&"
import script from "./QualityPPsManagerForm.vue?vue&type=script&lang=ts&"
export * from "./QualityPPsManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports